<template>
  <component
    :is="drawerComponent"
    v-model="model"
  />
</template>

<script lang="ts" setup>
const model = defineModel<boolean>({
  default: false,
})

const themeStyleStore = useThemeStyleStore()

const themedDrawers = import.meta.glob('../Theme/*/Layout/MobileDrawer.client.vue')
const defaultDrawer = defineAsyncComponent(() => import('./DefaultMobileDrawer.client.vue'))

const drawerComponent = computed(() => {
  const themedDrawerPath = `../Theme/${themeStyleStore.frame}/Layout/MobileDrawer.client.vue`
  const themedDrawer = themedDrawers[themedDrawerPath]

  return themedDrawer ? defineAsyncComponent(themedDrawer) : defaultDrawer
})
</script>

<style>
/*
  Quasar QDrawer uses setTimeout (150ms) internally, not transitionend.
  Keep drawer/backdrop visible long enough for the custom slide animation.
*/
.q-drawer:has(.fast-mobile-drawer),
.q-drawer:has(.fast-websphere-mobile-drawer) {
  transition: transform 0.4s ease !important;
}

.q-body--layout-animate .q-drawer:has(.fast-mobile-drawer),
.q-body--layout-animate .q-drawer:has(.fast-websphere-mobile-drawer) {
  transition: transform 0.4s ease !important;
}

.q-drawer:has(.fast-mobile-drawer).q-layout--prevent-focus,
.q-drawer:has(.fast-websphere-mobile-drawer).q-layout--prevent-focus {
  visibility: visible !important;
}

.q-drawer__backdrop {
  transition: background-color 0.4s ease !important;
}

.q-body--layout-animate .q-drawer__backdrop {
  transition: background-color 0.4s ease !important;
}

.q-drawer__backdrop.hidden {
  display: block !important;
  pointer-events: none !important;
}
</style>
